import { LOCALES } from 'i18n/locales';

export const createWorkpackPageIntl = {
    [LOCALES.ENGLISH]: {
        'createWorkpackPage.page.title': 'Create PDF - NUAR',
        'createWorkpackPage.title': 'Create PDF',
        'createWorkpackPage.title.summary': 'Create PDF summary',
        'createWorkpackPage.purpose.breadcrumb': 'Create PDF',
        'createWorkpackPage.purpose.title': 'Create PDF',
        'createWorkpackPage.workpack.purpose': 'PDF type',
        'createWorkpackPage.purpose.purpose': 'Purpose',
        'createWorkpackPage.purpose.hint': 'Reason for creating a PDF',
        'createWorkpackPage.purpose.currentOrganisation': 'You are working on behalf of {organisationName}.',
        'createWorkpackPage.purpose.organisationNotice': 'This work pack is for work carried out on behalf of {organisationName}. Please sign out and change your organisation if this isn\'t correct.',
        'createWorkpackPage.purpose.prework': 'Pre-work or site investigation',
        'createWorkpackPage.purpose.planned': 'Planned works',
        'createWorkpackPage.purpose.emergency': 'Emergency works',
        'createWorkpackPage.purpose.other': 'Other',
        'createWorkpackPage.purpose.planned.notice': 'To continue creating a PDF for this purpose, please proceed to “Make enquiry” as asset owners and their third parties may need to provide permission for works.',
        'createWorkpackPage.purpose.other.description.label': 'Purpose description',
        'createWorkpackPage.purpose.other.description.hint': 'Provide a brief description of why you require a work pack.',
        'createWorkpackPage.assetOwnerNotification': 'This map PDF will be available for download and offline use.',
        'createWorkpackPage.select.enquiry.type.title': 'Select enquiry type',
        'createWorkpackPage.confirmation.title': 'PDF Created',
        'createWorkpackPage.confirmation.message': 'Your PDF has been created. Check the',
        'createWorkpackPage.confirmation.pdfsLink': 'PDFs',
        'createWorkpackPage.confirmation.messageEnd': 'page to see the status of your PDF',
        'createWorkpackPage.confirmation.downloadButton': 'Download PDF',
        'createWorkpackPage.confirmation.viewWorkpacksButton': 'View all PDFs',
        'createWorkpackPage.omittedData.title': 'Data Omitted',
        'createWorkpackPage.omittedData.prefix': 'Data from the following Asset Owners will not be displayed in the work pack PDF:',
        'createWorkpackPage.omittedData.suffix': 'Please review page five of the work pack and follow the asset owners special requirements.'
    },
    [LOCALES.WELSH]: {
        'createWorkpackPage.page.title': '[Create PDF - NUAR]',
        'createWorkpackPage.title': '[Create PDF]',
        'createWorkpackPage.title.summary': '[Create PDF summary]',
        'createWorkpackPage.purpose.breadcrumb': '[Create PDF]',
        'createWorkpackPage.purpose.title': '[Create PDF]',
        'createWorkpackPage.workpack.purpose': '[PDF type]',
        'createWorkpackPage.purpose.purpose': '[Purpose]',
        'createWorkpackPage.purpose.hint': '[Reason for creating a PDF]',
        'createWorkpackPage.purpose.currentOrganisation': '[You are working on behalf of {organisationName}.]',
        'createWorkpackPage.purpose.organisationNotice': '[This work pack is for work carried out on behalf of {organisationName}. Please sign out and change your organisation if this isn\'t correct.]',
        'createWorkpackPage.purpose.prework': '[Pre-work or site investigation]',
        'createWorkpackPage.purpose.planned': '[Planned works]',
        'createWorkpackPage.purpose.emergency': '[Emergency works]',
        'createWorkpackPage.purpose.other': '[Other]',
        'createWorkpackPage.purpose.planned.notice': '[To continue creating a PDF for this purpose, please proceed to “Make enquiry” as asset owners and their third parties may need to provide permission for works.]',
        'createWorkpackPage.purpose.other.description.label': '[Purpose description]',
        'createWorkpackPage.purpose.other.description.hint': '[Provide a brief description of why you require a work pack.]',
        'createWorkpackPage.assetOwnerNotification': '[This map PDF will be available for download and offline use.]',
        'createWorkpackPage.select.enquiry.type.title': '[Select enquiry type]',
        'createWorkpackPage.confirmation.title': '[PDF Created]',
        'createWorkpackPage.confirmation.message': '[Your PDF has been created. Check the]',
        'createWorkpackPage.confirmation.pdfsLink': '[PDFs]',
        'createWorkpackPage.confirmation.messageEnd': '[page to see the status of your PDF]',
        'createWorkpackPage.confirmation.downloadButton': '[Download PDF]',
        'createWorkpackPage.confirmation.viewWorkpacksButton': '[View all PDFs]',
        'createWorkpackPage.omittedData.title': '[Data Omitted]',
        'createWorkpackPage.omittedData.prefix': '[Data from the following Asset Owners will not be displayed in the work pack PDF:]',
        'createWorkpackPage.omittedData.suffix': '[Please review page five of the work pack and follow the asset owners special requirements.'
    }
};
